import React from 'react';

export default function Admin() {
	return (
		<div>
			<h1>Hello, Admin!</h1>
		</div>
	);
}
